import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { getKotActivity } from "store/slices/PropertyData";
import Layout from "../../layout";
import moment from "moment";
import { baseUrl } from "API/client/api";


const ResturantMenu = () => {

    const dispatch = useDispatch();
    const { userDetail } = useSelector(authenticationSeletor);
    const { access_token } = useSelector((state) => state.authentication);
    const { kotLogs } = useSelector((state) => state.AllData)
    const [exportFilter, setExportFilter] = useState({
        startDate: new Date(),
        endDate: new Date(),
        search: ''
    });

    const fetchKotLogs = () => {
        dispatch(getKotActivity(userDetail?.propertyId))
    }

    useEffect(() => {
        fetchKotLogs()
    }, [])

    const exportHandler = async () => {
        const params = `?propertyId=${userDetail?.propertyId}&fromDate=${moment(exportFilter.startDate).format('YYYY-MM-DD')}&toDate=${moment(exportFilter.endDate).format('YYYY-MM-DD')}${exportFilter.search ? `&bookingCode=${exportFilter.search}` : ''}`
        fetch(`${baseUrl}booking/kitchen-audit-pdf${params}`, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${access_token}`,
                "Content-Type": "application/json"
            },
        })
            .then(res => res.blob())
            .then(blob => {
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'Kitchen-Audit-Trial.pdf';
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            });
    };


    return (
        <Layout
            title="Kitchen Logs"
            extraButton="Kitchen Audit Trial"
            extraBtnHandler={exportHandler}
            setFromDate={(date) =>
                setExportFilter({ ...exportFilter, startDate: date })
            }
            searchfilter={true}
            setToDate={(date) => setExportFilter({ ...exportFilter, endDate: date })}
            searchType={"date"}
            fromDate={exportFilter.startDate}
            toDate={exportFilter.endDate}
            primarySearch={true}
            primaryValue={exportFilter.search}
            setPrimaryValue={(val) =>
                setExportFilter({ ...exportFilter, search: val })
            }
            primaryPlaceholder="Booking Code or Order Id"
        >
            <h5 className="text-dark pb-2">Kitchen Logs</h5>
            <div className="table-responsive">
                <table className="table table-bordered table-hover table-sm">
                    <thead>
                        <tr>
                            <th>SN.</th>
                            <th>Order Id</th>
                            <th>Action</th>
                            <th>Activity</th>
                            <th>Performed By</th>
                            <th>Date & Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            kotLogs?.length > 0 ?
                                [...kotLogs]?.reverse()?.map((item, i) => (
                                    <tr key={i}>
                                        <td className="fs-8">{i + 1}</td>
                                        <td className="fs-8">{item?.bookingCode ? item?.bookingCode : '-'}</td>
                                        <td className="fs-8">{item?.action ? item?.action : '-'}</td>
                                        <td className="fs-8">{item?.operation ? item?.operation : '-'}</td>
                                        <td className="fs-8 text-primary">{item?.actionBy ? item?.actionBy : '-'}</td>
                                        <td className="fs-8 text-success">{item?.createdAt ? moment(item?.createdAt).format('DD-MM-YYYY HH:mm') : '-'}</td>
                                    </tr>
                                )) : 'No data'
                        }
                    </tbody>
                </table>
            </div>
        </Layout>
    );
};

export default ResturantMenu;
